export const CONTENT_TEXT = 'content-text';
